import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";
import i18n from "i18next";

class DavetliEtkinlikService {
  getList(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/DavetliEtkinlik/get-list-by-filter?${toDataSourceRequestString(
          dataState,
        )}`,
      )
      .then((response) => {
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }

  getForExcel(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/DavetliEtkinlik/get-list-for-excel?${toDataSourceRequestString(
          dataState,
        )}`,
      )
      .then((response) => response.data);
  }

  getById(id) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/DavetliEtkinlik/get-by-id/${id}`)
      .then((response) => response.data?.data ?? response.data)
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response?.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  add(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliEtkinlik/add`, data)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess =
          response.data?.message ?? response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response?.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  update(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliEtkinlik/update`, data)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess =
          response.data?.message ?? response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response?.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  changeStatus(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliEtkinlik/change-status`, data)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess =
          response.data?.message ?? response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        const messageKey = err.response?.data?.message;
        defaultAlertMessages.MessageDetailError = messageKey
          ? i18n.t(messageKey)
          : JSON.stringify(err.response?.data);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  getReport() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/DavetliEtkinlik/get-report`)
      .then((response) => response.data);
  }
}

export default new DavetliEtkinlikService();
